import React, { useState } from 'react';
import { Popover } from 'antd';
import SyringeYes from './img/syringe-yes.png';
import SyringeNo from './img/syringe-no.png';
import './css/VaccinationStatus.css';

const VaccinationStatus = ({ vaccinations, size = 40 }) => {
  const [visible, setVisible] = useState({});

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-CN');
  };

  const getVaccinationStatus = (date, label, key) => {
    const content = date ? `${label}于 ${formatDate(date)} 接种` : `未接种${label}`;
    const icon = date ? 
      <img src={SyringeYes} alt="Vaccinated" className="vaccination-icon" style={{ width: `${size}px`, height: `${size}px` }} /> : 
      <img src={SyringeNo} alt="Not Vaccinated" className="vaccination-icon" style={{ width: `${size}px`, height: `${size}px` }} />;
    
    return (
      <Popover 
        content={content} 
        trigger="hover"
      >
        <span onClick={() => setVisible(prev => ({ ...prev, [key]: !prev[key] }))}>{icon}</span>
      </Popover>
    );
  };

  return (
    <div className="vaccination-status">
      {getVaccinationStatus(vaccinations.first, '猫三联① ', 'first')}
      {getVaccinationStatus(vaccinations.second, '猫三联② ', 'second')}
      {getVaccinationStatus(vaccinations.third, '猫三联③ ', 'third')}
      {getVaccinationStatus(vaccinations.rabies, '狂犬病疫苗 ', 'rabies')}
    </div>
  );
};

export default VaccinationStatus;
